import functions from '../../services/functions'
import device from '../../api/device'
import {
  GET_SITE_CAMERA_EVENT_REQUEST,
  GET_SITE_CAMERA_EVENT_SUCCESS,
  GET_SITE_CAMERA_EVENT_FAILURE
} from '../mutation-types'

// initial state
const state = {
  events: {},
  eventSnapshots: {},
  lastEventId: null,
  status: {
    getEvent: {}
  }
}

// getters
const getters = {
  events: function (state) {
    return state.events
  },
  event: function (state) {
    return function (eventId) {
      return state.events[eventId]
    }
  },
  lastEventId: function (state) {
    return state.lastEventId
  },
  lastEvent: function (state, getters) {
    return getters.event(state.lastEventId)
  }
}

// actions
const actions = {
  getSiteCameraEvent: function ({commit, dispatch, getters}, {cameraId, eventId}) {
    return new Promise((resolve, reject) => {
      commit(GET_SITE_CAMERA_EVENT_REQUEST, {eventId: eventId})
      device.getSiteCameraEvent(getters.camera(cameraId).siteId, cameraId, eventId).then(
        res => {
          if (res.body[0] instanceof Object) {
            if (functions.hasAllKeys(res.body[0], [
              'event_id',
              'device_id',
              'watch',
              'type',
              'timestamp',
              'bounding_box',
              'status'
            ])) {
              commit(GET_SITE_CAMERA_EVENT_SUCCESS, {
                eventId: eventId,
                event: {
                  eventId: res.body[0].event_id,
                  cameraId: res.body[0].device_id,
                  watch: res.body[0].watch,
                  type: res.body[0].type !== 'netloss' ? res.body[0].type : res.body[0].status ? 'online' : 'offline',
                  timestamp: res.body[0].timestamp,
                  boundingBox: res.body[0].bounding_box
                }
              })
              resolve()
              if (res.body[0].type === 'netloss') dispatch('getSiteCamera', cameraId)
            } else {
              console.log('getSiteCameraEvent failed')
              commit(GET_SITE_CAMERA_EVENT_FAILURE, {eventId: eventId})
              reject({
                status: res.status,
                statusText: res.statusText,
                body: res.body,
                successButText: 'incorrect api response'
              })
            }
          } else {
            console.log('getSiteCameraEvent failed')
            commit(GET_SITE_CAMERA_EVENT_FAILURE, {eventId: eventId})
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_SITE_CAMERA_EVENT_FAILURE, {eventId: eventId})
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  }
}

// mutations
const mutations = {
  [GET_SITE_CAMERA_EVENT_REQUEST]: function (state, data) {
    state.status.getEvent = {...state.status.getEvent, [data.eventId]: 'requested'}
  },
  [GET_SITE_CAMERA_EVENT_SUCCESS]: function (state, data) {
    state.status.getEvent = {...state.status.getEvent, [data.eventId]: 'successful'}
    state.events = {...state.events, [data.eventId]: data.event}
    state.lastEventId = data.eventId
  },
  [GET_SITE_CAMERA_EVENT_FAILURE]: function (state, data) {
    state.status.getEvent = {...state.status.getEvent, [data.eventId]: 'failed'}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js